import { createStore, storeKey } from 'vuex'
import {SlideGenerator} from '@/helpers'

export default createStore({
  state: {
    isLoading: false,
    book: {},
    bookReviews: {},
    bookmarks: {},
    booksInstituteByCategoryPage: {},
    categories: {},
    categoriesInstitute: {},
    categoriesInstituteSelectListIndex: 0,
    categoriesImperdibili: {},
    categoriesImperdibiliSelectListIndex: 0,
    classesSelectListIndex: 0,
    profile: {},
    searchResults: {},
    booksClass: {},
    booksClassPage: {},
    booksInstitute: {},
    booksInstitutePage: {},
    booksInstituteByCategory: {},
    booksUser: {},
    booksUserPage: {},
    featuredGenre: {},
    featuredGenrePage: {},
    featuredClass: {},
    featuredGenreIndex: 1,
    featuredClassIndex: 0,
    instituteClasses: {},
    classId: 1,
    preferred: {},
    shared: {}
  },
  getters: {
    isLoading(state) {
      return state.isLoading;
    },
    profile(state) {
      if(state.profile) {
        if(Object.keys(state.profile).length) {
          return state.profile
        } else {
          return false;
        }
      }
      return null;
    },
    profileInstitute(state) {
      if(state.profile) {
        if(Object.keys(state.profile).length) {
          return state.profile.institute
        } else {
          return false;
        }
      }
      return null;
    },
    profileMates(state) {
      if(state.profile) {
        if(Object.keys(state.profile).length) {
          return state.profile.mates
        } else {
          return false;
        }
      }
      return null;
    },
    categories(state) {
      if(Object.keys(state.categories).length) {
        return state.categories
      }
      return null;
    },
    categoriesSelectList(state) {
      if(Object.keys(state.categories).length) {
        return state.categories.map(function(v) {
          return {id: v.id, text: v.description, value: v.id}
        })
      }
      return null;
    },
    categoriesInstitute(state) {
      if(Object.keys(state.categoriesInstitute).length) {
        return state.categories
      }
      return null;
    },
    categoriesInstituteSelectList(state) {
      if(Object.keys(state.categoriesInstitute).length) {
        return state.categoriesInstitute.map(function(v) {
          return {id: v.id, text: v.description, value: v.id}
        })
      }
      return [{ id:0, text: 'Tutte...', value: 0}];
    },
    categoriesImperdibiliSelectList(state) {
      if(Object.keys(state.categoriesImperdibili).length) {
        return state.categoriesImperdibili.map(function(v) {
          return {id: v.id, text: v.description, value: v.id}
        })
      }
      return null;
    },
    categoriesImperdibili(state) {
      if(Object.keys(state.categoriesImperdibili).length) {
        return state.categoriesImperdibili
      }
      return null;
    },
    book(state) {
      if(Object.keys(state.book).length) {
        return state.book
      }
      return null;
    },
    bookReviews(state) {
      if(Object.keys(state.bookReviews).length) {
        return state.bookReviews
      }
      return null;
    },
    bookReviewsMoreToLoad(state) {
      if(Object.keys(state.bookReviews).length) {
        return state.bookReviews.reviews.next_page_url;
      }
      return null;
    },
    bookReviewsCurrentPage(state) {
      if(Object.keys(state.bookReviews).length) {
        return state.bookReviews.reviews.current_page;
      }
      return null;
    },
    bookmarks(state) {
      if(Object.keys(state.bookmarks).length) {
        return state.bookmarks
      }
      return null;
    },
    preferred(state) {
      if(Object.keys(state.preferred).length) {
        return state.preferred
      }
      return null;
    },
    shared(state) {
      if(Object.keys(state.shared).length) {
        return state.shared
      }
      return null;
    },
    searchResults(state) {
      if(Object.keys(state.searchResults).length) {
        return state.searchResults
      }
      return null;
    },
    booksClass(state) {
      if(Object.keys(state.booksClass).length) {
        return state.booksClass
      }
      return null;
    },
    booksInstitute(state) {
      if(Object.keys(state.booksInstitute).length) {
        return state.booksInstitute
      }
      return null;
    },
    booksInstituteByCategory(state) {
      if(Object.keys(state.booksInstituteByCategory).length) {
        return state.booksInstituteByCategory
      }
      return null;
    },
    booksUser(state) {
      if(Object.keys(state.booksUser).length) {
        return state.booksUser
      }
      return null;
    },
    booksInstituteByCategoryPage(state) {
      if(Object.keys(state.booksInstituteByCategoryPage).length) {
        return state.booksInstituteByCategoryPage
      }
      return { data: { 
        current_page: 1 
      }};
    },
    featuredGenre(state) {
      if(Object.keys(state.featuredGenre).length) {
        return state.featuredGenre
      }
      return null;
    },
    featuredGenrePage(state) {
      if(Object.keys(state.featuredGenrePage).length) {
        return state.featuredGenrePage
      }
      return { data: { 
        current_page: 1 
      }};
    },
    featuredClass(state) {
      if(Object.keys(state.featuredClass).length) {
        return state.featuredClass
      }
      return null;
    },
    booksClassPage(state) {
      if(Object.keys(state.booksClassPage).length) {
        return state.booksClassPage
      }
      return { data: { 
        current_page: 1 
      }};
    },
    booksInstitutePage(state) {
      if(Object.keys(state.booksInstitutePage).length) {
        return state.booksInstitutePage
      }
      return { data: { 
        current_page: 1 
      }};
    },
    booksUserPage(state) {
      if(Object.keys(state.booksUserPage).length) {
        return state.booksUserPage
      }
      return { data: { 
        current_page: 1 
      }};
    },
    instituteClasses(state) {
      if(state.instituteClasses) {
        if(Object.keys(state.instituteClasses).length) {
          return state.instituteClasses
        } else {
          return false;
        }
      }
      return null;
    },
    instituteClassesSelectList(state) {
      if(state.instituteClasses) {
        if(Object.keys(state.instituteClasses).length) {
          const selectList =  state.instituteClasses.map(function(v) {
            return {id: v.id, text: v.class, value: v.class}
          })
          selectList.unshift({ id: 0, text: 'Tutte...', value: '0'});
          return selectList;
        } else {
          return [ { id: 0, text: 'Tutte...', value: 0} ];
        }
      }
      return [ { id: 0, text: 'Tutte...', value: 0} ];
    },
    piuConsigliati(state) {
      const books = state.booksInstitute;

      if(books && Array.isArray(books) ) {
        return SlideGenerator(books, 1);
      } 

      return [];

    },
    piuConsigliati(state) {
      const books = state.booksInstitute;

      if(books && Array.isArray(books) ) {
        return SlideGenerator(books, 1);
      } 

      return [];

    },
    suggeritiPerTe(state) {
      const books = state.booksUser;

      if(books && Array.isArray(books) ) {
        return SlideGenerator(books, 1);
      } 

      return [];
    },
    featuredGenreSlide(state) {
      const books = state.featuredGenre;

      if(books && Array.isArray(books) ) {
        return SlideGenerator(books, 1);
      } 

      return [];
    },
    featuredClassSlide(state) {
      const books = state.featuredClass;

      if(books && Array.isArray(books) ) {
        return SlideGenerator(books, 1);
      } 

      return [];
    },
    classId(state) {
      return state.classId;
    },
    featuredGenreIndex(state) {
      return state.featuredGenreIndex;
    },
    featuredClassIndex(state) {
      if(state.featuredClassIndex) {
        return state.featuredClassIndex;
      }
      return '0';
    },
    categoriesInstituteSelectListIndex(state) {
      return state.categoriesInstituteSelectListIndex;
    },
    categoriesImperdibiliSelectListIndex(state) {
      return state.categoriesImperdibiliSelectListIndex;
    },
    classesSelectListIndex(state) {
      return state.classesSelectListIndex;
    }
  },
  mutations: {
    startLoading(state) {
      state.isLoading = true;
    },
    stopLoading(state) {
      state.isLoading = false;
    },
    setProfile (state, profile) {
      state.profile = profile
    },
    setCategories (state, categories) {
      state.categories = categories
    },
    setCategoriesInstitute (state, categoriesInstitute) {
      state.categoriesInstitute = categoriesInstitute
    },
    setCategoriesImperdibili (state, categoriesImperdibili) {
      state.categoriesImperdibili = categoriesImperdibili
    },
    setBook (state, book) {
      state.book = book
    },
    setBookReviews (state, book) {
      state.bookReviews = book
    },
    resetBookReviews (state) {
      state.bookReviews = {}
    },
    setBookmarks (state, bookmarks) {
      state.bookmarks = bookmarks
    },
    setPreferred (state, preferred) {
      state.preferred = preferred
    },
    setShared (state, shared) {
      state.shared = shared
    },
    setBooksClass (state, booksClass) {
      if(Array.isArray(state.booksClass)) {
        state.booksClass = state.booksClass.concat(booksClass)
      } else {
        state.booksClass = booksClass
      }
    },
    resetBooksClass (state) {
      state.booksClass = {}
    },
    setBooksInstitute (state, booksInstitute) {
      if(Array.isArray(state.booksInstitute)) {
        state.booksInstitute = state.booksInstitute.concat(booksInstitute)
      } else {
        state.booksInstitute = booksInstitute
      }
    },
    setBooksInstitutePage (state, booksInstitutePage) {
      state.booksInstitutePage = booksInstitutePage
    },
    setBooksUserPage (state, booksUserPage) {
      state.booksUserPage = booksUserPage
    },
    setBooksInstituteByCategory (state, booksInstituteByCategory) {
      if(Array.isArray(state.booksInstituteByCategory)) {
        state.booksInstituteByCategory = state.booksInstituteByCategory.concat(booksInstituteByCategory)
      } else {
        state.booksInstituteByCategory = booksInstituteByCategory
      }
    },
    resetBooksInstituteByCategory (state) {
      state.booksInstituteByCategory = {}
    },
    setBooksImperdibiliByCategory (state, booksImperdibiliByCategory) {
      state.booksImperdibiliByCategory = booksImperdibiliByCategory
    },
    resetBooksImperdibiliByCategory (state) {
      state.booksImperdibiliByCategory = {}
    },
    setBooksUser (state, booksUser) {
      if(Array.isArray(state.booksUser)) {
        state.booksUser = state.booksUser.concat(booksUser)
      } else {
        state.booksUser = booksUser
      }
    },
    setSearchResults (state, searchResults) {
      state.searchResults = searchResults
    },
    setInstituteClasses (state, instituteClasses) {
      if(Array.isArray(instituteClasses)) {
        instituteClasses.forEach(function(e) {
          if(e.class == state.profile.class) {
              state.classId = e.id;
          }
        })
        state.instituteClasses = instituteClasses
      } else {
        const ic = Object.values(instituteClasses);
        ic.forEach(function(e) {
          if(e.class == state.profile.class) {
              state.classId = e.id;
          }
        })
        state.instituteClasses = ic
      }
    },
    unsetProfile (state, profile) {
      state.profile = null
    },
    incProfileReadings (state, profile) {
      state.profile.readings += 1;
    },
    decProfileReadings (state, profile) {
      state.profile.readings -= 1;
    },
    incProfileRecommendedBooks (state, profile) {
      state.profile.recommended_books += 1;
    },
    setClassId (state, classId) {
      state.classId = 1
    },
    setPiuConsigliati (state, piuConsigliati) {
      state.piuConsigliati = piuConsigliati
    },
    setFeaturedGenre (state, featuredGenre) {
      if(Array.isArray(state.featuredGenre)) {
        state.featuredGenre = state.featuredGenre.concat(featuredGenre)
      } else {
        state.featuredGenre = featuredGenre
      }
    },
    setFeaturedGenrePage (state, featuredGenrePage) {
      state.featuredGenrePage = featuredGenrePage
    },
    setFeaturedGenreIndex (state, featuredGenreIndex) {
      state.featuredGenreIndex = featuredGenreIndex
    },
    setBooksInstituteByCategoryPage (state, booksInstituteByCategoryPage) {
      state.booksInstituteByCategoryPage = booksInstituteByCategoryPage
    },
    setBooksClassPage (state, booksClassPage) {
      state.booksClassPage = booksClassPage
    },
    resetFeaturedGenre (state) {
      state.featuredGenre = {}
    },
    setFeaturedClass (state, featuredClass) {
      state.featuredClass = featuredClass
    },
    resetFeaturedClass (state) {
      state.featuredClass = {}
    },
    setFeaturedClassIndex (state, featuredClassIndex) {
      state.featuredClassIndex = featuredClassIndex
    },
    setCategoriesInstituteSelectListIndex (state, categoriesInstituteSelectListIndex) {
      state.categoriesInstituteSelectListIndex = categoriesInstituteSelectListIndex
    },
    setCategoriesImperdibiliSelectListIndex (state, categoriesImperdibiliSelectListIndex) {
      state.categoriesImperdibiliSelectListIndex = categoriesImperdibiliSelectListIndex
    },
    setClassesSelectListIndex (state, classesSelectListIndex) {
      state.classesSelectListIndex = classesSelectListIndex
    },
  },
  actions: {
      loadProfile(context) {

        if(context.getters.profile) {
          return;
        }

        return new Promise(function(resolve, reject) {
          context.commit('startLoading');
          axios.get(apipath + '/api/profile')
          .then(function(response) {
              context.commit('stopLoading');
              context.commit('setProfile', response.data);
              resolve(response.data);
          })
          .catch(function(error) {
              context.commit('stopLoading');
              reject(error);
          })
        });

      },
      loadCategories(context) {

        if(context.getters.categories) {
          return;
        }

        return new Promise(function(resolve, reject) {
          context.commit('startLoading');
          axios.get(apipath + '/api/categories')
          .then(function(response) {
              context.commit('stopLoading');
              context.commit('setCategories', response.data);
              resolve(response.data);
          })
          .catch(function(error) {
              context.commit('stopLoading');
              reject(error);
          })
        });

      },
      loadCategoriesInstitute(context) {

        if(context.getters.categoriesInstitute) {
          return;
        }

        return new Promise(function(resolve, reject) {
          context.commit('startLoading');
          axios.get(apipath + '/api/categories/institute')
          .then(function(response) {
              context.commit('stopLoading');
              response.data.unshift({ id: 0, description: 'Tutti...', count: 0})
              context.commit('setCategoriesInstitute', response.data);
              context.commit('setCategoriesInstituteSelectListIndex', 0);
              resolve(response.data);
          })
          .catch(function(error) {
              context.commit('stopLoading');
              reject(error);
          })
        });

      },
      loadCategoriesImperdibili(context) {
        if(context.getters.categoriesImperdibili) {
          return;
        }

        return new Promise(function(resolve, reject) {
          context.commit('startLoading');
          axios.get(apipath + '/api/categories/imperdibili')
          .then(function(response) {
              const generi = response.data.unshift({ id: 0, description: 'Tutti...', count: 0})
              context.commit('setFeaturedGenreIndex', 0);
              context.commit('setCategoriesImperdibili', response.data);
              context.commit('stopLoading');
              resolve(response.data);
          })
          .catch(function(error) {
              context.commit('stopLoading');
              reject(error);
          })
        });

      },
      loadBooksByCategory(context, id) {
        return new Promise(function(resolve, reject) {
          context.commit('startLoading');
          axios.get(apipath + '/api/books/category/' + id)
          .then(function(response) {
              context.commit('stopLoading');
              resolve(response.data);
          })
          .catch(function(error) {
              context.commit('stopLoading');
              reject(error);
          })
        });
      },
      loadBooksInstituteByCategory(context, {id, nextPage}) {

        let page = 1;

        if(nextPage) {
          page += context.getters.booksInstituteByCategoryPage.data.current_page;
        } 

        return new Promise(function(resolve, reject) {
          context.commit('startLoading');
          axios.get(apipath + '/api/books/category/' + id + '/institute', {
            params: {page: page}
          })
          .then(function(response) {
              context.commit('stopLoading');
              context.commit('setBooksInstituteByCategory', response.data.data);
              context.commit('setBooksInstituteByCategoryPage', response);
              resolve(response.data.data);
          })
          .catch(function(error) {
              context.commit('stopLoading');
              reject(error);
          })
        });
      },
      loadBook(context, id) {
        return new Promise(function(resolve, reject) {
          context.commit('startLoading');
          axios.get(apipath + '/api/book/' + id)
          .then(function(response) {
              context.commit('stopLoading');
              context.commit('setBook', response.data);
              resolve(response.data);
          })
          .catch(function(error) {
              context.commit('stopLoading');
              reject(error);
          })
        });
      },
      loadBookReviews(context, id) {
        return new Promise(function(resolve, reject) {

          let page = 1 ;

          if(context.getters.bookReviewsCurrentPage) {
            page += context.getters.bookReviewsCurrentPage;
          }

          context.commit('startLoading');
          axios.get(apipath + '/api/book/' + id + '/reviews', {
            params: { page: page}
          })
          .then(function(response) {
              context.commit('stopLoading');
              context.commit('setBookReviews', response.data);
              resolve(response.data);
          })
          .catch(function(error) {
              context.commit('stopLoading');
              reject(error);
          })
        });
      },
      loadBookReview(context, id) {
        return new Promise(function(resolve, reject) {

          context.commit('startLoading');
          axios.get(apipath + '/api/book/' + id + '/review')
          .then(function(response) {
              context.commit('stopLoading');
              resolve(response.data);
          })
          .catch(function(error) {
              context.commit('stopLoading');
              reject(error);
          })
        });
      },
      searchBooks(context, searchValue) {
        return new Promise(function(resolve, reject) {
          context.commit('startLoading');
          axios.post(apipath + '/api/books/search', {
            q: searchValue
          })
          .then(function(response) {
              context.commit('stopLoading');
              context.commit('setSearchResults', response.data);
              resolve(response.data);
          })
          .catch(function(error) {
              context.commit('stopLoading');
              reject(error);
          })
        });
      },
      loadBookmarks(context) {

        if(context.getters.bookmarks) {
          return;
        }

        return new Promise(function(resolve, reject) {
          context.commit('startLoading');
          axios.get(apipath + '/api/bookmarks')
          .then(function(response) {
              context.commit('stopLoading');
              context.commit('setBookmarks', response.data);
              resolve(response.data);
          })
          .catch(function(error) {
              context.commit('stopLoading');
              reject(error);
          })
        });
      },
      loadPreferred(context) {

        if(context.getters.preferred) {
          return;
        }

        return new Promise(function(resolve, reject) {
          context.commit('startLoading');
          axios.get(apipath + '/api/preferred')
          .then(function(response) {
              context.commit('stopLoading');
              context.commit('setPreferred', response.data);
              resolve(response.data);
          })
          .catch(function(error) {
              context.commit('stopLoading');
              reject(error);
          })
        });
      },
      loadShared(context) {

        if(context.getters.shared) {
          return;
        }

        return new Promise(function(resolve, reject) {
          context.commit('startLoading');
          axios.get(apipath + '/api/shared')
          .then(function(response) {
              context.commit('stopLoading');
              context.commit('setShared', response.data);
              resolve(response.data);
          })
          .catch(function(error) {
              context.commit('stopLoading');
              reject(error);
          })
        });
      },
      bookComment(context, book) {
        return new Promise(function(resolve, reject) {
          context.commit('startLoading');
          axios.put(apipath + '/api/book/' + book.id + '/comment', book)
          .then(function(response) {
              context.commit('stopLoading');
              context.commit('setBookmarks', {});
              context.commit('incProfileReadings');
              resolve(response.data);
          })
          .catch(function(error) {
              context.commit('stopLoading');
              reject(error);
          })
        });
      },
      bookCommentUpdate(context, book) {
        return new Promise(function(resolve, reject) {
          context.commit('startLoading');
          axios.post(apipath + '/api/book/' + book.id + '/comment', book)
          .then(function(response) {
              context.commit('stopLoading');
              context.commit('setBookmarks', {});
              resolve(response.data);
          })
          .catch(function(error) {
              context.commit('stopLoading');
              reject(error);
          })
        });
      },
      bookPreferredAdd(context, book) {
        return new Promise(function(resolve, reject) {
          context.commit('startLoading');
          axios.post(apipath + '/api/preferred/add', { book_id: book })
          .then(function(response) {
              context.commit('stopLoading');
              context.commit('setPreferred', {});
              resolve(response.data);
          })
          .catch(function(error) {
              context.commit('stopLoading');
              reject(error);
          })
        });
      },
      bookPreferredRemove(context, book) {
        return new Promise(function(resolve, reject) {
          context.commit('startLoading');
          axios.post(apipath + '/api/preferred/remove', { book_id: book })
          .then(function(response) {
              context.commit('stopLoading');
              context.commit('setPreferred', {});
              resolve(response.data);
          })
          .catch(function(error) {
              context.commit('stopLoading');
              reject(error);
          })
        });
      },
      bookCommentDelete(context, book) {
        return new Promise(function(resolve, reject) {
          context.commit('startLoading');
          axios.delete(apipath + '/api/book/' + book.id + '/comment')
          .then(function(response) {
              context.commit('stopLoading');
              context.commit('setBookmarks', {});
              context.commit('decProfileReadings');
              resolve(response.data);
          })
          .catch(function(error) {
              context.commit('stopLoading');
              reject(error);
          })
        });
      },
      bookSuggestion(context, suggestion) {
        return new Promise(function(resolve, reject) {
          context.commit('startLoading');
          axios.post(apipath + '/api/suggestion', suggestion)
          .then(function(response) {
              context.commit('stopLoading');
              context.commit('incProfileRecommendedBooks');
              resolve(response.data);
          })
          .catch(function(error) {
              context.commit('stopLoading');
              reject(error);
          })
        });
      },
      bookShareAdd(context, data) {
        return new Promise(function(resolve, reject) {
          context.commit('startLoading');
          axios.post(apipath + '/api/share/add', { book_id: data.book_id, user_id: data.user_id })
          .then(function(response) {
              context.commit('stopLoading');
              context.commit('setPreferred', {});
              resolve(response.data);
          })
          .catch(function(error) {
              context.commit('stopLoading');
              reject(error);
          })
        });
      },
      loadBooksClass(context, {id, nextPage}) {

        let page = 1;

        if(nextPage) {
          page += context.getters.booksClassPage.data.current_page;
        }

        return new Promise(function(resolve, reject) {
          context.commit('startLoading');
          axios.get(apipath + '/api/books/class/' + id, {             
            params: { page: page }
          })
          .then(function(response) {
              context.commit('stopLoading');
              context.commit('setClassesSelectListIndex', id);
              context.commit('setBooksClass', response.data.data);
              context.commit('setBooksClassPage', response);
              resolve(response.data);
          })
          .catch(function(error) {
              context.commit('stopLoading');
              reject(error);
          })
        });
      },
      loadBooksInstitute(context, {nextPage}) {

        let page = 1;
        
        if(nextPage) {
          page += context.getters.booksInstitutePage.data.current_page;
        } else {
          if(context.getters.booksInstitute) {
            page = context.getters.booksInstitute.length / 6 + 1;
          }
        }

        return new Promise(function(resolve, reject) {
          context.commit('startLoading');
          axios.get(apipath + '/api/books/institute', {
            params: { page: page }
          })
          .then(function(response) {
              context.commit('stopLoading');
              context.commit('setBooksInstitute', response.data.data);
              context.commit('setBooksInstitutePage', response);
              resolve(response.data);
          })
          .catch(function(error) {
              context.commit('stopLoading');
              reject(error);
          })
        });
      },
      loadBooksUser(context, nextPage) {
        let page = 1;

        if(nextPage) {
          page += context.getters.booksUserPage.data.current_page;
        }

        return new Promise(function(resolve, reject) {
          context.commit('startLoading');
          axios.get(apipath + '/api/books/for/user',  {
            params: { page: page }
          })
          .then(function(response) {
              context.commit('stopLoading');
              context.commit('setBooksUser', response.data.data);
              context.commit('setBooksUserPage', response);
              resolve(response.data);
          })
          .catch(function(error) {
              context.commit('stopLoading');
              reject(error);
          })
        });
      },
      loadFeaturedGenre(context, {id, nextPage} ) {

        let page = 1;

        if(nextPage) {
          page += context.getters.featuredGenrePage.data.current_page;
        }

        return new Promise(function(resolve, reject) {
          context.commit('startLoading');
          axios.get(apipath + '/api/books/featured/genre/' + id, {
            params: { page: page }
          })
          .then(function(response) {
              context.commit('stopLoading');
              context.commit('setFeaturedGenre', response.data.data);
              context.commit('setFeaturedGenrePage', response);
              context.commit('setFeaturedGenreIndex', id);
              resolve(response.data);
          })
          .catch(function(error) {
              context.commit('stopLoading');
              reject(error);
          })
        });
      },
      loadFeaturedClass(context, id) {

        if(context.getters.featuredClass) {
          return;
        }

        return new Promise(function(resolve, reject) {
          context.commit('startLoading');
          axios.get(apipath + '/api/books/featured/class/' + id)
          .then(function(response) {
              context.commit('stopLoading');
              context.commit('setFeaturedClass', response.data.data);
              context.commit('setFeaturedClassIndex', id);
              resolve(response.data);
          })
          .catch(function(error) {
              context.commit('stopLoading');
              reject(error);
          })
        });
      },
      loadInstituteClasses(context, institute) {

        if(! institute) {
          return;
        }

        if(context.getters.instituteClasses) {
          return;
        }

        return new Promise(function(resolve, reject) {
          context.commit('startLoading');
          axios.get(apipath + '/api/classes/institute/' + institute)
          .then(function(response) {
              context.commit('setInstituteClasses', response.data);
              context.commit('stopLoading');
              resolve(response.data);
          })
          .catch(function(error) {
              context.commit('stopLoading');
              reject(error);
          })
        });
      },

      logout(context) {
        return new Promise(function(resolve, reject) {
          context.commit('setProfile', null);
          axios.get(apipath + '/api/logout')
          .then(function(response) {
              resolve();
          })
          .catch(function(error) {
              reject(error);
          })
        });

      },
  },
  modules: {
  }
})
